import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=1d76741b&scoped=true&"
var script = {}
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=1d76741b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76741b",
  null
  
)

export default component.exports